import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome"
import {AssignmentsModuleIcon} from '@csrc/assets/icons'

export const assignmentNavigation = [
	{
		id: 'ast.assignments',
		title: 'assignment.nav.assignments',
		icon: <FontAwesomeIcon icon={AssignmentsModuleIcon}/>,
		navLink: '/assignment/list',
		action: 'call',
		resource: 'AST_MANAGE_ASSIGNMENT'
	}
]
